import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from 'lib/api-client';
import { QueryConfig } from 'lib/react-query';
import { TraceGroup } from 'types/api';
import { env } from 'config/env';
import { http, HttpResponse, delay } from 'msw';

type GetTraceGroupResponse = {
    trace_group: TraceGroup;
};

export const getTraceGroup = async (
    traceGroupId: string,
): Promise<TraceGroup> => {
    const response = await api.get<
        GetTraceGroupResponse,
        GetTraceGroupResponse
    >(`/app/api/v1/trace-groups/${traceGroupId}`);
    return response.trace_group;
};

export const getTraceGroupQueryOptions = (traceGroupId: string) => {
    return queryOptions({
        queryKey: ['traceGroup', traceGroupId],
        queryFn: () => getTraceGroup(traceGroupId),
    });
};

type UseTraceGroupOptions = {
    queryConfig?: QueryConfig<typeof getTraceGroupQueryOptions>;
};

export const useTraceGroup = (
    traceGroupId: string,
    { queryConfig }: UseTraceGroupOptions = {},
) => {
    return useQuery({
        ...getTraceGroupQueryOptions(traceGroupId),
        ...queryConfig,
    });
};

export const getTraceGroupMSWHandler = (traceGroup: TraceGroup) => {
    return http.get(
        `${env.API_URL}/app/api/v1/trace-groups/:traceGroupId`,
        async () => {
            await delay(1000);
            return HttpResponse.json({ trace_group: traceGroup });
        },
    );
};
